import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import {
  Button,
  FormControl,
  Grid,
  Paper,
  Typography,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import Alert from "@material-ui/lab/Alert";
import { useStyles } from "./classes";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import LocationFail from "../../components/errorPages/LocationFail";
import DataLoadingFail from "../../components/errorPages/DataLodingFail";

import SearchInput from "./SearchInput";
import SearchItems from "./SearchItems";
import { useDispatch } from "react-redux";
import { hideSearch, setSearch } from "../../redux/actions/search";

const Search = (props) => {
  const [initialValues] = useState({
    // eslint-disable-line
    id: "",
    type: "",
    coordinates: { lat: "", lng: "" },
    name: "",
    location: "",
  });
  const classes = useStyles();

  let history = useHistory();

  // const [location, setLocation] = useState({
  //   loaded: false,
  //   coordinates: { let: "", lng: "" },
  // });

  const [alert, setAlert] = useState({
    showAlert: false,
    severity: "success",
    message: "",
  });

  const [open, setOpen] = React.useState(false);
  const [show, setShow] = React.useState(false);

  //update
  const onSearch = (e) => {
    if (e.type === "restaurant") {
      localStorage.setItem("searchSuccess", JSON.stringify({ e }));
      history.push(`/restaurant/${e.id}/search`);
    } else {
      localStorage.setItem("searchSuccess", JSON.stringify({ e }));
      dispatch(setSearch(e));

      history.push("/search", e);
    }
  };

  // validation schema
  let validationSchema = Yup.object().shape({
    // coordinates: Yup.object().shape({
    //   lat: Yup.number().required(),
    //   lng: Yup.number().required(),
    // }),
    id: Yup.string().required(""),
    type: Yup.string().required(""),
  });

  const validateInput = (values) => {
    if (values.type === "restaurant") {
      if (values.id) {
        return false;
      } else {
        return true;
      }
    } else {
      if (
        values.coordinates &&
        values.coordinates.lat &&
        values.coordinates.lng &&
        values.id &&
        values.type
      ) {
        return false;
      } else {
        return true;
      }
    }
  };

  const handleOpen = (v) => {
    setOpen(v);
  };

  const dialogOpen = (e) => {
    setShow(e);
  };

  let dispatch = useDispatch();
  useEffect(() => {
    dispatch(hideSearch());
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <div className={classes.root}>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={12} md={12} sm={12} lg={8}>
            <Paper className={classes.paper}>
              <Typography className={classes.title}>
                Food Menus On The Go
              </Typography>
              <Typography className={classes.subtitle}>
                <span className={classes.spanText}>GottaMenu</span> is your
                source for restaurant menus
              </Typography>
              <div>
                <Formik
                  initialValues={initialValues}
                  onSubmit={onSearch}
                  validationSchema={validationSchema}
                  enableReinitialize
                >
                  {({ dirty, isValid, values, setFieldValue }) => {
                    return (
                      <Form>
                        <Grid container className={classes.searchContainer}>
                          <Grid
                            item
                            xs={12}
                            sm={4}
                            md={4}
                            lg={4}
                            className={classes.gapSpace}
                          >
                            <FormControl
                              fullWidth
                              className={classes.formControlOne}
                            >
                              <SearchInput
                                setFieldValue={setFieldValue}
                                values={values}
                                handleOpen={handleOpen}
                              />
                            </FormControl>
                            {/* <FormControl fullWidth className={classes.formControlTwo} >
                            <SearchInput setFieldValue={setFieldValue} values = {values}/>
                            </FormControl> */}
                          </Grid>
                          <Grid item xs={12} sm={7} md={7} lg={7}>
                            <FormControl fullWidth>
                              <SearchItems
                                setFieldValue={setFieldValue}
                                dialogOpen={dialogOpen}
                              />
                            </FormControl>
                          </Grid>
                          <Grid item xs={12} sm={12} md={1} lg={1}>
                            <Button
                              variant="contained"
                              className={classes.button}
                              startIcon={
                                <SearchIcon style={{ fontSize: 30 }} />
                              }
                              type="submit"
                              disabled={validateInput(values)}
                            ></Button>
                          </Grid>
                        </Grid>
                      </Form>
                    );
                  }}
                </Formik>
              </div>
              {alert.showAlert && (
                <Grid item md={12}>
                  <Alert
                    severity={alert.severity}
                    onClose={() =>
                      setAlert({
                        ...alert,
                        showAlert: false,
                      })
                    }
                  >
                    {/* {alert.message} */}
                  </Alert>
                </Grid>
              )}
            </Paper>
          </Grid>
        </Grid>
      </div>
      <LocationFail open={open} handleOpen={handleOpen} />
      <DataLoadingFail show={show} dialogOpen={dialogOpen} />
    </>
  );
};

export default Search;
